import { jsx as _jsx } from 'react/jsx-runtime.js';
import { Stack, Text, TextLink } from '@stepstone-genesis/components';
import { Trans } from '@stepstone-platform/i18n';
import { languageSpecificConfigSelector } from '../../../redux/core/siteConfig/siteConfigSlice.js';
import { useAppSelector } from '../../../redux/hooks.js';
import { useTrack } from '../../../tracking/common/hooks/useTrack.js';
const TERM_OF_USE = 'terms-of-use-link';
const PROTECTION_POLICY = 'data-protection-link';
export const LoginConsent = () => {
    const { dataProtectionPolicyUrl, termsOfUseUrl } = useAppSelector(languageSpecificConfigSelector);
    const { trackBtnClick } = useTrack('standard');
    const onTermsOfUseClick = () => {
        trackBtnClick({ uniqueName: 'termsOfUse' });
    };
    const onDataProtection = () => {
        trackBtnClick({ uniqueName: 'dataProtection' });
    };
    return (_jsx(Stack, { direction: "vertical", spacing: "spaceM", py: "spaceM", "data-testid": "login-consent-container", children: _jsx(Text, { fontSize: ['fontSizeXs', 'fontSizeS'], color: 'colorGreyDark', lineHeight: "lineHeightXxs", children: _jsx(Trans, { i18nKey: 'loginregistration.login.legalNote', components: [
                    _jsx(TextLink, { "data-testid": TERM_OF_USE, variant: "bare", href: termsOfUseUrl, onClick: onTermsOfUseClick }, TERM_OF_USE),
                    _jsx(TextLink, { "data-testid": PROTECTION_POLICY, variant: "bare", href: dataProtectionPolicyUrl, onClick: onDataProtection }, PROTECTION_POLICY),
                ] }) }) }));
};
//# sourceMappingURL=LoginConsent.js.map